/** The `/fleet/reference/v1` lists the vehicle General tab labels ids from. */
export const REFERENCE_LIST = {
	EQUIPMENT: "equipment",
	INTENTS: "intents",
	BODY_STYLES: "body-styles",
	COLORS: "colors",
} as const;

export type ReferenceList =
	(typeof REFERENCE_LIST)[keyof typeof REFERENCE_LIST];

export interface ReferenceListItem {
	id: string;
	label: string;
}

/** A catalogue model, picked in the Specifications drawer grouped by brand. */
export interface VehicleModelOption {
	id: string;
	brand: string;
	fullName: string;
}
